
$(function () {

    var _init = function () {

        $.fn.switchIsOn = function () {
            if ($(this).is(".widget-switch")) {
                return $(this).children("input").is(":checked");
            }

            return false;
        };

        $.fn.switchIsOff = function () {
            if ($(this).is(".widget-switch")) {
                return !$(this).children("input").is(":checked");
            }

            return false;
        };

        $.fn.switchVal = function () {
            if ($(this).is(".widget-switch")) {
                return $(this).children("input").val();
            }

            return null;
        };

        $(".widget-switch").each(function (idx, element) {

            //var checked = $(element).children("input").is(":checked");    
            var checked = $(element).switchIsOn();

            var _toggleChecked = function (isChecked) {
                $(element).children("input").prop("checked", isChecked);
                var usingValue = $(element).hasClass("using-value");

                if (isChecked) {
                    $(element).children("input").attr("checked", "checked");
                    $(element).addClass("on");
                }
                else {
                    $(element).children("input").removeAttr("checked");
                    $(element).removeClass("on")
                }

                if (!usingValue) {
                    $(element).children("input").val(isChecked.toString());
                }
            };

            $(element).off("click").on("click", function () {
                //var c = $(element).children("input").is(":checked");
                var c = $(element).switchIsOn();

                _toggleChecked(!c);
                $(element).trigger(WidgetEvents.STEMS_ON_CHANGE);
            });

            _toggleChecked(checked);
        })
    };

    _init();

    $(document).ajaxComplete(function () {
        _init();
    })
})